module.exports = __webpack_public_path__ + "static/media/message_send.97a84f5f.png";